import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ShieldCheck, LogIn } from "lucide-react";
import { startLogin, fetchCurrentUser } from "../services/auth";
import { Button } from "../components/ui/button";

/**
 * Login page — SPEC-20260505-1712.
 *
 * Substitui o mock-login (4 cards de perfil) por redirect ao Keycloak via
 * `/api/auth/oidc/login` do backend BFF. Backend cuida de PKCE, state,
 * callback e cookie HttpOnly. Frontend só inicia o redirect.
 *
 * Se o usuário já estiver logado (cookie válido), redireciona pra `returnTo`.
 */
export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get("returnTo") ?? "/";

  useEffect(() => {
    // Cookie pode já estar válido (ex: usuário voltou via histórico) — redirect.
    void fetchCurrentUser().then((user) => {
      if (user) navigate(returnTo, { replace: true });
    });
  }, [navigate, returnTo]);

  return (
    <div className="min-h-screen bg-background grid place-items-center p-6">
      <div className="w-full max-w-md space-y-8">
        {/* Branding */}
        <div className="flex items-center gap-3 justify-center">
          <div className="w-10 h-10 rounded-md bg-primary text-primary-foreground grid place-items-center font-bold text-base shadow-sm">
            W
          </div>
          <div>
            <h1 className="text-xl font-semibold tracking-tight">Wynk Orchestrator</h1>
            <p className="text-xs text-muted-foreground font-mono-tight">WOS</p>
          </div>
        </div>

        {/* Card */}
        <div className="rounded-md border-2 border-border-strong bg-surface p-6 space-y-5">
          <div className="flex items-start gap-3">
            <div className="p-2 rounded shrink-0 bg-primary-soft text-primary-soft-fg">
              <ShieldCheck size={18} strokeWidth={1.75} />
            </div>
            <div>
              <h2 className="text-sm font-semibold">Acesso restrito</h2>
              <p className="text-xs text-muted-foreground mt-1 leading-snug">
                Autenticação via Wynk Identity Platform (Keycloak).
                Você será redirecionado para inserir credenciais.
              </p>
            </div>
          </div>

          <Button
            variant="primary"
            size="md"
            className="w-full"
            onClick={() => startLogin(returnTo)}
          >
            <LogIn size={16} strokeWidth={1.75} />
            Entrar com Wynk
          </Button>

          <p className="text-[11px] text-muted-foreground text-center">
            Após login, você volta automaticamente para{" "}
            <code className="font-mono-tight">{returnTo}</code>.
          </p>
        </div>
      </div>
    </div>
  );
}
